import React, { useEffect, useState } from "react";
import grievanceBanner from "../images/Grievance.jpg";
import axios from "axios";
import'../Loading.css'

interface PolicyDoc {
  policyDocsId: number;
  policyId: number;
  policyDescription: string;
}
const GrievancePolicy = () => {
    const  policyId =4;
  const [policyDoc, setPolicyDoc] = useState<PolicyDoc | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
  const fetchPolicyDoc = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetActivePolicyDocs?policyId=${policyId}`
        );
         const data = response.data[0];
        if (data && data.policyDescription) {
          // Decode HTML entities
          const textarea = document.createElement("textarea");
          textarea.innerHTML = data.policyDescription;
          data.policyDescription = textarea.value;
        }
        setPolicyDoc(data);
      } catch (error) {
        console.error("Failed to fetch policy content", error);
      } finally {
        setLoading(false);
      }
    };

    if (policyId) {
      fetchPolicyDoc();
    }
  }, [policyId]);

  if (loading) return  <div className="relative w-full h-[200px] flex justify-center items-center py-10">
   <div className="absolute top-2/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 loader"></div>
 </div>;
  if (!policyDoc) return <div className="p-10">No policy found.</div>;
  return (
    <div className="w-full">
      <div className="relative w-full">
        <img
          src={grievanceBanner}
          alt="Grievance Policy Banner"
          className="w-full h-full object-cover"
        />
        <div className="absolute top-1/2 left-0 xs:left-5 transform -translate-y-1/2 w-4/5 md:w-2/5 sm:w-3/5">
          <h1 className="text-[#184A84] text-lg sm:text-xl md:text-4xl font-bold bg-opacity-80 px-4 py-2 rounded inline-block">
            Grievance Redressal Policy
          </h1>
        </div>
      </div>
      <div className="flex justify-center w-full mt-8">
        <div className="w-[90%] md:w-[80%] space-y-8 bg-white md:p-8 text-gray-700 text-sm leading-6 shadow-md">
              <h2 className="text-xl font-semibold mb-2 text-center text-black ">Grievance Redressal Policy</h2>
            <div
        className="prose max-w-none"
        dangerouslySetInnerHTML={{ __html: policyDoc.policyDescription }}
      />
        </div>
      </div>
    </div>
  );
};

export default GrievancePolicy;
